import React, { useState } from 'react'
import HeaderComponent from '../../../../../components/HeaderComponent/HeaderComponent'
import styles from "./AddCustomer.module.css"
import { IoClose } from "react-icons/io5";
import { RiDeleteBin6Line } from "react-icons/ri";
import { MdEdit } from "react-icons/md";
import { IoIosSave } from "react-icons/io";
import { SearchInput, SubmitButton, TextComponent, Modal, InputField, PhoneInput } from "../../../../../components";
import { useNavigate } from 'react-router-dom';



const AddCustomer = () => {
    const navigate = useNavigate();

    // const [Name, setName] = useState("");
    const [FirstName, setFirstName] = useState("");
    const [LastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [location, setLocation] = useState("");
    const [notes, setNotes] = useState("");
    const [contactNo, setContactNo] = useState("");
    const [editingId, setEditingId] = useState(null);
    const [editLabel, setEditLabel] = useState("");
    const [fields, setFields] = useState([
        // { id: Date.now(), label: "Primary Contact Number", value: "" },
    ]);


    const addField = () => {
        const newField = {
            id: Date.now(),
            label: "Optional Field",
            value: "",
        };
        setFields((prev) => [...prev, newField]);
    };
    const removeField = (id) => {
        setFields((prev) => prev.filter((f) => f.id !== id));
    };

    const handleChange = (id, newValue) => {
        setFields((prev) =>
            prev.map((f) => (f.id === id ? { ...f, value: newValue } : f))
        );
    };

    const handleEdit = (field) => {
        setEditingId(field.id);
        setEditLabel(field.label);
    };

    const saveEdit = (id) => {
        setFields((prev) =>
            prev.map((f) => (f.id === id ? { ...f, label: editLabel } : f))
        );
        setEditingId(null);
        setEditLabel("");
    };


    return (
        <div className={styles.mainCont}>
            <HeaderComponent
                heading={"Create New Customer"}
                // onSearch={(e) => console.log(e.target.value)}
                // onSubmit={() => navigate("/productionManagement/ReciepeBuilder")}
                // submitButtonText={"Add Customer"}
                showBackIcon={true}
                showFilterIcon={false}
                showSubmitButton={false}
                showSearch={false}
            />

            <div className={styles.subCont}>
                <div className={styles.doubleInput}>
                    <InputField
                        label={"First Name"}
                        placeholder={"Iva Ryan"}
                        inputStyle={{
                            backgroundColor: "#F7F8F9",
                            border: "1.5px solid #E8ECF4",
                        }}
                        innerInput={{ backgroundColor: "#F7F8F9" }}
                        value={FirstName}
                        onChange={(e) => setFirstName(e.target.value)}
                    />
                    <InputField
                        label={"Last Name"}
                        placeholder={"Iva Ryan"}
                        inputStyle={{
                            backgroundColor: "#F7F8F9",
                            border: "1.5px solid #E8ECF4",
                        }}
                        innerInput={{ backgroundColor: "#F7F8F9" }}
                        value={LastName}
                        onChange={(e) => setLastName(e.target.value)}
                    />

                </div>
                <div className={styles.doubleInput}>
                    <PhoneInput
                        label={"Contact"}
                        placeholder={"(636) 296-7838"}
                        InputclassName={styles.PhoneinputClassname}
                        InnerInputclassName={styles.Phoneinput}
                        labelClass={styles.PhoneLabelClassname}
                        maxLength={10}
                        value={contactNo}
                        onChange={(value) => setContactNo(value)}
                    />

                    <InputField
                        label={"Email Address"}
                        placeholder={"Iiva@mail.com"}
                        inputStyle={{
                            backgroundColor: "#F7F8F9",
                            border: "1.5px solid #E8ECF4",
                        }}
                        innerInput={{ backgroundColor: "#F7F8F9" }}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
                <div className={styles.doubleInput}>
                    <InputField
                        label={"Location"}
                        placeholder={"417 Bicetown Road, New York, NY 10018"}
                        inputStyle={{
                            backgroundColor: "#F7F8F9",
                            border: "1.5px solid #E8ECF4",
                        }}
                        innerInput={{ backgroundColor: "#F7F8F9" }}
                        value={location}
                        onChange={(e) => setLocation(e.target.value)}
                    />
                    <InputField
                        label={"Notes"}
                        placeholder={"e.g., preferred vendor, storage instructions"}
                        inputStyle={{
                            backgroundColor: "#F7F8F9",
                            border: "1.5px solid #E8ECF4",
                        }}
                        innerInput={{ backgroundColor: "#F7F8F9" }}
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                    />
                </div>

                <div className={styles.addFieldCont}>
                    {fields.map((field) => (
                        <div key={field.id} className={styles.fieldContainer}>
                            <div className={styles.fieldHeader}>
                                {editingId === field.id ? (
                                    <InputField
                                        placeholder="Enter here…"
                                        inputStyle={{
                                            backgroundColor: "#F7F8F9",
                                            border: "1.5px solid #E8ECF4",
                                        }}
                                        innerInput={{ backgroundColor: "#F7F8F9" }}
                                        className={styles.editInput}
                                        value={editLabel}
                                        onChange={(e) => setEditLabel(e.target.value)}
                                        autoFocus
                                    />
                                ) : (

                                    <TextComponent className={styles.fieldLabel} text={field.label} />
                                )}

                                <div className={styles.iconGroup}>
                                    {editingId === field.id ? (
                                        <IoIosSave onClick={() => saveEdit(field.id)} size={20} />

                                    ) : (
                                        <>
                                            <RiDeleteBin6Line onClick={() => removeField(field.id)} size={20} />
                                            < MdEdit onClick={() => handleEdit(field)} size={20} />

                                        </>
                                    )}
                                </div>
                            </div>
                            <InputField
                                // label={"Location"}
                                placeholder={"optional field"}
                                inputStyle={{
                                    backgroundColor: "#F7F8F9",
                                    border: "1.5px solid #E8ECF4",
                                }}
                                innerInput={{ backgroundColor: "#F7F8F9" }}
                                value={field.value}
                                onChange={(value) => handleChange(field.id, value)}
                            />
                        </div>
                    ))}

                </div>
                <div className={styles.buttonCont}>
                    <SubmitButton title="Add " secondary onClick={addField} btnClass={styles.Btn} btnContainerClass={styles.btnContainer} />
                    <SubmitButton title="Create New Customer" onClick={() => navigate("/AdminCustomerManagement/CustomerManagementDetails")} primary btnContainerClass={styles.btnContainer} />
                </div>
            </div>
        </div>
    )
}

export default AddCustomer
